export interface Devicepersian_Interface {
  id:number,
  device_id:number,
  device_name:String,
  dsc:String,
  quantity:String,
  quantity_sub:String,
  username:String,
  persianDate:String,
  del:boolean,
}

export function Empty_Devicepersian_Interface():Devicepersian_Interface{
  return{
    id:0,
    device_id:0,
    device_name:'',
    quantity:'',
    quantity_sub:'',
    dsc:'',
    username:'',
    persianDate:'',
    del:false
  }
}
